import {
    FETCH_ORDER_STATUS_OVERVIEW_REQUEST,
    FETCH_ORDER_STATUS_OVERVIEW_SUCCESS,
    FETCH_ORDER_STATUS_OVERVIEW_FAILURE,
} from "../actions/fetchOrderStatusOverviewAction";

const initialState = {
    data: { order_status: [], review_status: [] },
    loading: false,
    error: null,
};

const orderStatusOverviewReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ORDER_STATUS_OVERVIEW_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case FETCH_ORDER_STATUS_OVERVIEW_SUCCESS:
            return {
                ...state,
                data: action.payload.data,
                loading: false,
                error: null,
            };
        case FETCH_ORDER_STATUS_OVERVIEW_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };
        default:
            return state;
    }
};

export default orderStatusOverviewReducer;
